const urls = {
  // brokerageBase: "https://contact-brokerage-staging.contact.eg",
  brokerageBase: "https://brokerage-api.contact.eg",
};

export default urls;
